import type { PublicSpiritPayload } from "./spirit";
import { type divisionTables, hasResults, poolPlayComplete, poolProgress } from "./standings";
import type { Division, ScheduledGame } from "./types";

/** The tab and its body share this projection. Registered teams alone belong
 * in Teams; an empty division must not create an empty Tables destination. */
export function boardTableSections(
  tables: { division: Division; groups: ReturnType<typeof divisionTables> }[],
  schedule: ScheduledGame[],
  spirit: PublicSpiritPayload,
) {
  return tables.map((table) => {
    const progress = poolProgress(schedule, table.division.id);
    const decided = poolPlayComplete(schedule, table.division.id);
    return {
      ...table,
      groups: table.groups.filter((group) => group.rows.length > 0 && (hasResults(group.rows) || progress.total > 0)),
      progress,
      decided,
      showBracket: decided || progress.total === 0,
      bracket: schedule.filter((game) => game.stage === "bracket" && game.divisionId === table.division.id),
      spiritRows: spirit.standings.find((entry) => entry.divisionId === table.division.id)?.rows ?? [],
    };
  }).filter((table) => table.groups.length > 0 || table.bracket.length > 0 || table.spiritRows.length > 0);
}
